import { removeUnit } from '@js/utils'


export const setupFavicon = (url: string): void => {
  const icoUrl = url;
  const favicon = document.querySelector("link[rel*='icon']") as HTMLLinkElement || document.createElement('link')
  favicon.type = 'image/x-icon'
  favicon.rel = 'shortcut icon'
  favicon.href = icoUrl
  document.getElementsByTagName('head')[0].appendChild(favicon)
  console.debug('favicon set up')
}


export function getHeight(el: HTMLElement): number {
  let val: number | string = el.offsetHeight
  if (isNaN(val) === true || val === 0) {
    val = removeUnit(el.style.height)
  }
  return typeof val === 'string' ? parseInt(val) : val
}


export const setRandomPosition = (element: HTMLElement): void => {
  if (element.id !== 'undefined') {
    const xMin = getWidth(element)
    const xMax = window.innerWidth
    const yMin = getHeight(element)
    const yMax = window.innerHeight
    element.style.position = 'absolute'
    element.style.left = Math.floor(Math.random() * (xMax - xMin)) + 'px'
    element.style.top = Math.floor(Math.random() * (yMax - yMin)) + 'px'
  }
}


export function getWidth(el: HTMLElement): number {
  let val: number | string = el.offsetWidth
  if (isNaN(val) === true || val === 0) {
    val = removeUnit(el.style.width)
  }
  return typeof val === 'string' ? parseInt(val) : val
}


export function displayBtnByClass(classname: string, state: boolean): void {
  const btns = document.querySelectorAll('.' + classname)
  btns.forEach(btn => {
    if (state === true) {
        console.debug('display button', btn)
        ;(btn as HTMLElement).style.display = 'block'
    } else {
        console.debug('hide button', btn)
        ;(btn as HTMLElement).style.display = 'none'
    }
  })
}


export const lookForClassInChildren = (elem: HTMLElement | null, classname: string): HTMLElement | undefined => {
  if (!elem) return undefined
  
  const children = elem.childNodes
  if (children === undefined || children.length === 0) {
    console.debug('no children for element', elem)
    return undefined
  }
  for (let j = 0; j < children.length; j++) {
    const child = children[j] as HTMLElement
    if (child.classList?.contains(classname)) {
      return child
    }
  }
  return undefined
}


export const replaceCssClass = (el: HTMLElement, toAdd: string, toRemove: string): void => {
  el.classList.add(toAdd)
  el.classList.remove(toRemove)
  console.debug("replacing class", toRemove, "by", toAdd)
}


export function changeOpacityOnHover(
  btn: HTMLElement,
  element: HTMLElement
): void {

  btn.addEventListener("mouseenter", () => {
    element.style.opacity = "0.8"
  })

  btn.addEventListener("mouseleave", () => {
    element.style.opacity = "1"
  })
}


export function setPageOverflowY(overflow: boolean): void {
  const val = overflow ? 'visible' : 'hidden'

  const htmlEl = document.documentElement
  htmlEl.style.overflowY = val

  // Equivalent to $('html, body').scrollTop(0)
  window.scrollTo({ top: 0, behavior: 'auto' })
}


export const makeUnselectable = (el: HTMLElement): void => {
  el.classList.add('unselectable_text')
  ;(el as any).unselectable = 'on'
  ;(el as any).onselectstart = 'return false;'
  ;(el as any).onmousedown = 'return false;'
}
